import request from '../../axios';

export const postDirectLoanRequest = async () => {
  return await request.post(`/api/v2/payment/direct-loan-request`);
};
